import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, ViewChild } from '@angular/core';
import { LienItemModel } from '../../../../../models/menu/lien-item.model';
import { BreadcrumbsService } from '../../../../breadcrumbs/breadcrumbs.service';
import { View360itemComponent } from './view360item/view360item.component';

@Component({
  selector: 'app-view360',
  templateUrl: './view360.component.html',
  styleUrls: ['./view360.component.scss'],
})
export class View360Component implements OnInit{
  @HostListener('window:scroll', []) onWindowScroll() {
    const contentRefTop = this.contentRef.nativeElement.getBoundingClientRect().top;
    this.isPageScrolled = contentRefTop < this.HEIGHT_NAVBAR;
  }
  @ViewChild('view360Position', {static: true}) contentRef: ElementRef;
  @ViewChild('view360Menu', {static: true}) view360Menu: ElementRef;

  @Input() pageContent;
  @Input() set menuItems(items: QueryList<View360itemComponent>) {
    this._menuItems = items;
  }
  @Input() hideRetour: boolean;
  @Input() titre: string;
  @Input() route: Array<LienItemModel>;
  @Output() itemSelect = new EventEmitter<View360itemComponent>();

  isPageScrolled = false;
  HEIGHT_NAVBAR = 60;
  view360MenuWidth: number;
  mousePostionX: number;
  mouseDownPosition: number;
  widthLeftToView360: number;
  newWidthView360Menu: number;
  widthView360Min: number;
  isMouseDown = false;
  isSmallView360Menu = false;
  minView360Menu = 40;
  breakpointToSmallView360Menu = 100;
  defaultView360Menu = 280;
  maxView360Menu = 750;
  private _menuItems: QueryList<View360itemComponent>;

  constructor(private breadcrumbsService: BreadcrumbsService, private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.breadcrumbsService.breadcrumbUpdated.subscribe(() => {
      this.cdRef.detectChanges();
    });
    }

  public retourAction() {
    this.breadcrumbsService.navigateToPageRetour();
  }

  public get menuItems() {
    return this._menuItems;
  }

  public hasRetour(): boolean {
    return this.breadcrumbsService.hasRetour();
  }

  public onMouseAction(event: MouseEvent): void {
    this.mouseDownPosition = event.clientX;
    this.view360MenuWidth = this.view360Menu.nativeElement.offsetWidth;
    this.widthLeftToView360 = this.mouseDownPosition - this.view360MenuWidth;
    this.isMouseDown = event.buttons === 1;
  }

  public onMouseMove(event: MouseEvent): void {
    this.mousePostionX = event.clientX;
    this.widthView360Min = this.widthLeftToView360 + this.minView360Menu;
    if (this.isMouseDown && this.mousePostionX > this.widthView360Min && this.mousePostionX < this.maxView360Menu) {
      this.newWidthView360Menu = this.mousePostionX - this.widthLeftToView360;
    }
    if (this.newWidthView360Menu < this.breakpointToSmallView360Menu) {
      this.setView360MenuToSmall();
    } else {
      this.isSmallView360Menu = false;
    }
  }

  public toggleResizeView360Menu() {
    if (this.newWidthView360Menu < this.breakpointToSmallView360Menu) {
      this.setView360MenuTodefault();
    } else {
      this.setView360MenuToSmall();
    }
  }

  public setView360MenuToSmall() {
    this.newWidthView360Menu = this.minView360Menu;
    this.isSmallView360Menu = true;
  }

  public setView360MenuTodefault() {
    this.newWidthView360Menu = this.defaultView360Menu;
    this.isSmallView360Menu = false;
  }

  public getNewWidthView360Menu() {
    return this.newWidthView360Menu + 'px';
  }
}
